import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import TuneIcon from "@mui/icons-material/Tune";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import { Link as RouterLink } from "react-router";

interface ReportLink {
  label: string;
  to: string;
  icon: ReactNode;
}

const REPORTS: ReportLink[] = [
  { label: "Inventory report", to: "inventory-report", icon: <Inventory2Icon /> },
  { label: "Adjustment report", to: "adjustment-report", icon: <TuneIcon /> },
  { label: "Dispatch report", to: "dispatch-report", icon: <LocalShippingIcon /> },
  { label: "Receipt report", to: "receipt-report", icon: <MoveToInboxIcon /> },
  { label: "TOE report", to: "toe-report", icon: <LocalShippingIcon /> },
  { label: "eStore report", to: "estore-report", icon: <LocalShippingIcon /> },
  { label: "Toll report", to: "toll-report", icon: <LocalShippingIcon /> },
];

export const ReportHome = () => {
  return (
    <Box>
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 700 }}
      >
        Reports
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {REPORTS.map((report) => (
          <Button
            key={report.to}
            component={RouterLink}
            to={report.to}
            variant="outlined"
            size="large"
            startIcon={report.icon}
            sx={{
              minWidth: 220,
              justifyContent: "flex-start",
              py: 2,
            }}
          >
            {report.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};
